export function PaymentMethods() {
    return (
        <div><h4 className="primary-text mb-5">Payment Methods</h4></div>
    )
}